import { createContext } from 'utils/react-helpers';

const [VehicleBodiesProvider, useVehicleBodies] = createContext({
  name: 'VehicleBodiesContext',
});

export { VehicleBodiesProvider, useVehicleBodies };
